<template>
  <div class="markdown-show">
    <div class="markdown-html-only" v-html="contentToHtml"></div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import MarkdownIt from 'markdown-it'

export default defineComponent({
  props: {
    content: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {},
  setup(props) {
    const md = new MarkdownIt()
    const contentToHtml = computed(() => {
      return md.render(props.content)
    })
    return {
      contentToHtml,
    }
  },
})
</script>

<style lang="scss" >
.markdown-show {
  .markdown-html-only {
    @include markdown-html-only;
  }
}
</style>